import { create } from 'zustand'
import type { PublicAssessment } from '@really-assess/shared/assessments'
import { fetchPublicAssessment } from '../services/assessmentsApi'

interface AssessmentDefinitionState {
  slug: string | null
  definition: PublicAssessment | null
  isLoading: boolean
  error: string | null
  loadAssessment: (slug: string) => Promise<void>
  clearAssessment: () => void
}

export const useAssessmentDefinitionStore = create<AssessmentDefinitionState>((set) => ({
  slug: null,
  definition: null,
  isLoading: false,
  error: null,

  loadAssessment: async (slug: string) => {
    set({ isLoading: true, error: null, slug })
    try {
      const definition = await fetchPublicAssessment(slug)
      set({ definition, isLoading: false })
    } catch {
      set({
        definition: null,
        isLoading: false,
        error: 'This assessment is not available. It may be unpublished or the link is incorrect.',
      })
    }
  },

  clearAssessment: () => set({ slug: null, definition: null, error: null, isLoading: false }),
}))
